export { Icon } from './Icon';
export type { Props as IconProps } from './Icon';

export { iconsMap, iconNames } from './icons';
export type { IconName } from './icons';
